import React from 'react'
import { Transaction, TextContainer } from '../styles/stars'
import { LabelExtra } from '../styles/elements'
import { Icon } from '../styles/image'
import Score from './Score'
import up from '../assets/icons/uparrow.svg'
import down from '../assets/icons/downarrow.svg'

export default ({ title, date, isGain, price }) => (
  <Transaction>
    <Icon src={isGain ? up : down} />
    <TextContainer>
      <LabelExtra fontSize="14px" padding="0 10px" lh="35px">{title}</LabelExtra>
      <LabelExtra fontSize="12px" color="#777" padding="0 10px" lh="25px">{date}</LabelExtra>
    </TextContainer>
    <Score status="star">{(price > 0 ? price : (price * (-1)) + "-")}</Score>
  </Transaction>
)